import fetchApi from '../utilities/fetch/httpService'
import apiUrls  from '../utilities/consts/apiUrls'

// last_name, last_name, mobile, email, title, description, company_name, position

export const sendConsultingRequest = ({
                                        last_name, mobile, email, title, description, company_name, position
                                      }) =>
  fetchApi({
    url: apiUrls.consulting_request,
    body: {last_name, mobile, email, title, description, company_name, position},
    method: 'POST'
  })
